import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "roleManage-wrapper"
  }, [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("所属客户")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "400px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("所属客户"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption
    },
    on: {
      change: _vm.customerIdFun
    },
    model: {
      value: _vm.form.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "customerId", $$v);
      },
      expression: "form.customerId"
    }
  }, _vm._l(_vm.customerList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "top",
        title: item.name
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1);
  }), 1)], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("角色名称")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("角色名称"),
      allowClear: ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("状态")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("状态"),
      allowClear: ""
    },
    model: {
      value: _vm.form.status,
      callback: function ($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("下线")) + " ")]), _c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("上线")) + " ")])], 1)], 1), _c("a-form-item", [_c("a-button", {
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: function ($event) {
        return _vm.getRoleTable();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("查询")) + " ")])], 1), _c("a-form-item", [_vm.isAuth("home.customerRoleStore") ? _c("a-button", {
    staticClass: "select-bottom",
    attrs: {
      type: "add",
      icon: "plus"
    },
    on: {
      click: _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("新增角色")))]) : _vm._e()], 1)], 1), _c("standard-table", {
    staticClass: "marginT20",
    attrs: {
      tableData: _vm.tableData,
      tableHead: _vm.tableHead,
      loading: _vm.loading,
      bordered: "",
      pagination: _vm.pagination
    },
    on: {
      changeCurrent: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function ({
        index
      }) {
        return _c("div", {}, [_vm._v(" " + _vm._s(index + 1) + " ")]);
      }
    }, {
      key: "status",
      fn: function ({
        text,
        record
      }) {
        return [_c("a-switch", {
          attrs: {
            checked: text == 1 ? true : false
          },
          on: {
            click: function ($event) {
              return _vm.checkedFun(record);
            }
          }
        })];
      }
    }, {
      key: "action",
      fn: function ({
        record
      }) {
        return _c("div", {}, [_vm.isAuth("home.customerRoleConfig") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "primary",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "roleHomeCofing",
                params: {
                  id: record.id + "," + record.customerId
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("功能配置")))]) : _vm._e(), _vm.isAuth("home.customerRoleEdit") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleEdit(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e(), _vm.isAuth("home.customerRoleDelete") ? _c("a-button", {
          attrs: {
            type: "danger",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleDelete(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))]) : _vm._e()], 1);
      }
    }])
  }), _vm.dialogVisible ? _c("role-model", {
    attrs: {
      currentRow: _vm.currentRow,
      dialogVisible: _vm.dialogVisible,
      tableData: _vm.tableData
    },
    on: {
      ok: _vm.handleOk,
      cancel: function ($event) {
        _vm.dialogVisible = false;
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };